import { Reveal } from "@/components/Reveal";
import { useSite } from "@/lib/SiteContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faqs() {
  const { site, loading } = useSite();
  const faqs = site?.faqs || [];

  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8" data-testid="faqs-page">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold">Help</p>
        <h1 className="mt-3 font-serif text-3xl font-bold tracking-tight text-cream-text sm:text-4xl">
          Frequently Asked Questions
        </h1>
      </Reveal>
      <Reveal className="mt-10">
        {loading ? (
          <p className="text-sm text-cream-muted" data-testid="faqs-loading">Loading…</p>
        ) : faqs.length === 0 ? (
          <p className="rounded-3xl border border-choco-line bg-choco-light p-8 text-center text-sm text-cream-muted" data-testid="faqs-empty">
            Answers are on the way — please check back shortly.
          </p>
        ) : (
          <Accordion type="single" collapsible className="space-y-3" data-testid="faqs-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="rounded-2xl border border-choco-line bg-choco-light px-5" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left text-sm font-semibold text-cream-text hover:text-gold hover:no-underline sm:text-base">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-cream-muted">{f.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        )}
      </Reveal>
    </div>
  );
}
